// interview/InterviewAssignForms.js
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import Select from "react-select";
import ErrorMessage from "components/ErrorMessage";
import { useState, useContext } from "react";
import { FiLoader } from "react-icons/fi";
import { apiGet, apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/pathObj";
import useToastContext from "hooks/useToastContext";
import AuthContext from "context/AuthContext";

const InterviewAssignForms = ({
  setAssignFormModal,
  setPage,
  allRequest,
  currentItem,
  jobApply,
}) => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const { handleSubmit } = useForm({ mode: "onChange" });

  const [referenceLink, setReferenceLink] = useState([]);
  const [isReferenceError, setIsReferenceError] = useState(false);
  const [experienceType, setExperienceType] = useState("");
  const [selectForms, setSelectForms] = useState("");
  const [experienceError, setExperienceError] = useState("");
  const [experienceTypeForms, setExperienceTypeForms] = useState([]);
  const [formsError, setFormsError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); // ✅ new
  const { user } = useContext(AuthContext);

  const durationTypeOptions = [
    { key: "Weekly", value: "Weekly (7 days)" },
    { key: "Fortnight", value: "Fortnight (15 days)" },
    { key: "Monthly", value: "Monthly (31 days)" },
  ];

  const checkFields = () => {
    let isValid = true;
    if (experienceType === "") {
      setExperienceError(true);
      isValid = false;
    } else setExperienceError(false);
    if (selectForms === "") {
      setFormsError(true);
      isValid = false;
    } else setFormsError(false);
    if (referenceLink.length === 0) {
      setIsReferenceError(true);
      isValid = false;
    } else setIsReferenceError(false);
    return isValid;
  };

  const statusFormPage = (e) => {
    getFormList(e.target.value);
    setSelectForms(e.target.value);
  };

  const getFormList = async (data) => {
    try {
      const payload = { categoryType: data, companyID: user?.companyID };
      const res = await apiGet(apiPath.allForms, payload);
      setExperienceTypeForms(
        res?.data?.results?.map((item) => ({
          label: item?.formName,
          value: item?._id,
        })),
      );
    } catch (error) {
      console.log("error:", error);
    }
  };

  const onSubmit = async () => {
    try {
      const isValid = checkFields();
      if (!isValid) return;

      setIsSubmitting(true); // ✅ start loading

      let link = referenceLink?.map((item) => item?.value) || [];

      // Forms assigned, now change 'interviewStatus' to accepted
      const payload = {
        employeeID: jobApply.Employee._id,
        assignedForms: link,
        duration: experienceType,
        interviewStatus: "accepted",
      };

      const res = await apiPut(
        apiPath.ChangeInterviewStatusJob + "/" + currentItem._id,
        payload,
      );

      if (res?.data?.success) {
        allRequest();
        setPage(1);
        setAssignFormModal(false); // Close modal
        notification.success(
          "Interview Accepted & Forms Assigned Successfully",
        );
      } else {
        notification.error(res?.data?.message);
      }
    } catch (err) {
      console.log("err:", err);
    } finally {
      setIsSubmitting(false); // ✅ always stop loading
    }
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <form className="sm:py-4 sm:px-2 py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">Assign Forms</h3>
                <button
                  className="ml-auto flex items-center justify-center text-black border-2 rounded-full h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                  onClick={() => setAssignFormModal(false)}
                >
                  <span className="text-[#B8BBBF] text-4xl" title="Close">
                    ×
                  </span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <div className="grid sm:grid-cols-2">
                  <div className="md:py-4 sm:px-2 sm:py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <select
                        className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 peer"
                        placeholder=" "
                        onChange={(e) => {
                          statusFormPage(e);
                          setFormsError(false);
                        }}
                        value={selectForms}
                      >
                        <option value="">Select Forms</option>
                        <option key="hiring" value="hiring">Hiring</option>
                        <option key="onboarding" value="onboarding">Onboarding</option>
                      </select>
                      <label className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg">
                        Select Forms <span className="text-red-500">*</span>
                      </label>
                      {formsError && (
                        <ErrorMessage message="Please select forms." />
                      )}
                    </div>
                  </div>
                  <div className="md:py-4 sm:px-2 sm:py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <Select
                        isMulti
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            padding: "9px 4px",
                            borderRadius: "0.5rem",
                            border: "2px solid rgb(223 223 223);",
                          }),
                        }}
                        options={experienceTypeForms}
                        placeholder={
                          <>
                            Select Assign Forms{" "}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={referenceLink}
                        onChange={(item) => {
                          setReferenceLink(item);
                          setIsReferenceError(false);
                        }}
                      />
                      {isReferenceError && (
                        <ErrorMessage message="Please select assign forms." />
                      )}
                    </div>
                  </div>
                  <div className="md:py-4 sm:px-2 sm:py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <select
                        className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 peer"
                        placeholder=" "
                        value={experienceType}
                        onChange={(e) => {
                          setExperienceType(e.target.value);
                          setExperienceError(false);
                        }}
                      >
                        <option value="">Select Duration Type</option>
                        {durationTypeOptions?.map((res, index) => (
                          <option key={index} value={res.value}>
                            {res.value}
                          </option>
                        ))}
                      </select>
                      <label className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg">
                        Duration Type <span className="text-red-500">*</span>
                      </label>
                      {experienceError && (
                        <ErrorMessage message="Please select duration type." />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                <button
                  className="bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 ease-linear transition-all duration-150 inline-flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
                  type="button"
                  onClick={handleSubmit(onSubmit)}
                  disabled={isSubmitting} // ✅ prevent double submit
                >
                  {isSubmitting && (
                    <FiLoader className="animate-spin w-4 h-4" />
                  )}
                  {isSubmitting
                    ? "Assigning..."
                    : "Accept Interview & Assign Forms"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default InterviewAssignForms;





// // interview/InterviewAssignForms.js
// import { useTranslation } from "react-i18next";
// import { useForm } from "react-hook-form";
// import Select from "react-select";
// import ErrorMessage from "components/ErrorMessage";
// import { useState, useContext } from "react";
// import { apiGet, apiPut } from "../../utils/apiFetch";
// import apiPath from "../../utils/pathObj";
// import useToastContext from "hooks/useToastContext";
// import AuthContext from "context/AuthContext";

// const InterviewAssignForms = ({
//   setAssignFormModal,
//   setPage,
//   allRequest,
//   currentItem,
//   jobApply,
// }) => {
//   const { t } = useTranslation();
//   const notification = useToastContext();
//   const { handleSubmit } = useForm({ mode: "onChange" });

//   const [referenceLink, setReferenceLink] = useState([]);
//   const [isReferenceError, setIsReferenceError] = useState(false);
//   const [experienceType, setExperienceType] = useState("");
//   const [selectForms, setSelectForms] = useState("");
//   const [experienceError, setExperienceError] = useState("");
//   const [experienceTypeForms, setExperienceTypeForms] = useState([]);
//   const [formsError, setFormsError] = useState("");
//   const { user } = useContext(AuthContext);

//   const durationTypeOptions = [
//     { key: "Weekly", value: "Weekly (7 days)" },
//     { key: "Fortnight", value: "Fortnight (15 days)" },
//     { key: "Monthly", value: "Monthly (31 days)" },
//   ];

//   const checkFields = () => {
//     let isValid = true;
//     if (experienceType === "") {
//       setExperienceError(true);
//       isValid = false;
//     } else setExperienceError(false);
//     if (selectForms === "") {
//       setFormsError(true);
//       isValid = false;
//     } else setFormsError(false);
//     if (referenceLink.length === 0) {
//       setIsReferenceError(true);
//       isValid = false;
//     } else setIsReferenceError(false);
//     return isValid;
//   };

//   const statusFormPage = (e) => {
//     getFormList(e.target.value);
//     setSelectForms(e.target.value);
//   };

//   const getFormList = async (data) => {
//     try {
//       const payload = { categoryType: data, companyID: user?.companyID };
//       const res = await apiGet(apiPath.allForms, payload);
//       setExperienceTypeForms(
//         res?.data?.results?.map((item) => ({
//           label: item?.formName,
//           value: item?._id,
//         })),
//       );
//     } catch (error) {
//       console.log("error:", error);
//     }
//   };

//   const onSubmit = async () => {
//     try {
//       const isValid = checkFields();
//       if (!isValid) return;

//       let link = referenceLink?.map((item) => item?.value) || [];

//       // Forms assigned, now change 'interviewStatus' to accepted
//       const payload = {
//         employeeID: jobApply.Employee._id,
//         assignedForms: link,
//         duration: experienceType,
//         interviewStatus: "accepted",
//       };

//       const res = await apiPut(
//         apiPath.ChangeInterviewStatusJob + "/" + currentItem._id,
//         payload,
//       );

//       if (res?.data?.success) {
//         allRequest();
//         setPage(1);
//         setAssignFormModal(false); // Close modal
//         notification.success(
//           "Interview Accepted & Forms Assigned Successfully",
//         );
//       } else {
//         notification.error(res?.data?.message);
//       }
//     } catch (err) {
//       console.log("err:", err);
//     }
//   };

//   return (
//     <>
//       <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
//         <div className="relative w-auto my-6 mx-auto max-w-3xl">
//           <form className="sm:py-4 sm:px-2 py-8 px-7">
//             <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]">
//               <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
//                 <h3 className="text-xl font-semibold">Assign Forms</h3>
//                 <button
//                   className="ml-auto flex items-center justify-center text-black border-2 rounded-full h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
//                   onClick={() => setAssignFormModal(false)}
//                 >
//                   <span className="text-[#B8BBBF] text-4xl" title="Close">
//                     ×
//                   </span>
//                 </button>
//               </div>
//               <div className="relative p-6 flex-auto">
//                 <div className="grid sm:grid-cols-2">
//                   <div className="md:py-4 sm:px-2 sm:py-8 px-7">
//                     <div className="relative z-0 w-full group">
//                       <select
//                         className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 peer"
//                         placeholder=" "
//                         onChange={(e) => {
//                           statusFormPage(e);
//                           setFormsError(false);
//                         }}
//                         value={selectForms}
//                       >
//                         <option value="">Select Forms</option>
//                         <option  key="hiring" value="hiring">Hiring</option>
//                         <option  key="onboarding" value="onboarding">Onboarding</option>
//                       </select>
//                       <label className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg">
//                         Select Forms <span className="text-red-500">*</span>
//                       </label>
//                       {formsError && (
//                         <ErrorMessage message="Please select forms." />
//                       )}
//                     </div>
//                   </div>
//                   <div className="md:py-4 sm:px-2 sm:py-8 px-7">
//                     <div className="relative z-0 w-full group">
//                       <Select
//                         isMulti
//                         styles={{
//                           control: (baseStyles) => ({
//                             ...baseStyles,
//                             padding: "9px 4px",
//                             borderRadius: "0.5rem",
//                             border: "2px solid rgb(223 223 223);",
//                           }),
//                         }}
//                         options={experienceTypeForms}
//                         placeholder={
//                           <>
//                             Select Assign Forms{" "}
//                             <span className="text-red-500">*</span>
//                           </>
//                         }
//                         className="basic-multi-select"
//                         classNamePrefix="select"
//                         value={referenceLink}
//                         onChange={(item) => {
//                           setReferenceLink(item);
//                           setIsReferenceError(false);
//                         }}
//                       />
//                       {isReferenceError && (
//                         <ErrorMessage message="Please select assign forms." />
//                       )}
//                     </div>
//                   </div>
//                   <div className="md:py-4 sm:px-2 sm:py-8 px-7">
//                     <div className="relative z-0 w-full group">
//                       <select
//                         className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 peer"
//                         placeholder=" "
//                         value={experienceType}
//                         onChange={(e) => {
//                           setExperienceType(e.target.value);
//                           setExperienceError(false);
//                         }}
//                       >
//                         <option value="">Select Duration Type</option>
//                         {durationTypeOptions?.map((res, index) => (
//                           <option key={index} value={res.value}>
//                             {res.value}
//                           </option>
//                         ))}
//                       </select>
//                       <label className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg">
//                         Duration Type <span className="text-red-500">*</span>
//                       </label>
//                       {experienceError && (
//                         <ErrorMessage message="Please select duration type." />
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
//                 <button
//                   className="bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
//                   type="button"
//                   onClick={handleSubmit(onSubmit)}
//                 >
//                   Accept Interview & Assign Forms
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//       <div className="opacity-25 fixed inset-0 z-40 bg-black" />
//     </>
//   );
// };

// export default InterviewAssignForms;
